/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_TitleInputs */



/**
* | output |
* | --- |
* | "Minimum Gap Time" |
*
* @param {Ad_Template_Min_Gap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_title = /** @type {((inputs?: Ad_Template_Min_Gap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée minimale d'écart")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestlücke")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo minimo di intervallo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный интервал")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo mínimo de hueco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小间隔时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小ギャップ時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम अंतराल समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo mínimo de intervalo")
	return /** @type {LocalizedString} */ ("Minimum Gap Time")
});